import { render, staticRenderFns } from "./process-archive.vue?vue&type=template&id=486a1743"
import script from "./process-archive.vue?vue&type=script&lang=js"
export * from "./process-archive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports